import { render, staticRenderFns } from "./DashboardScholarshipIssueModal.vue?vue&type=template&id=ea788ecc&"
import script from "./DashboardScholarshipIssueModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardScholarshipIssueModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports